<p-card class="mx-2">
  <p-accordion [multiple]="true">
    <p-accordionTab
      header="{{
        'AutoPrintSetting.DetailTable.SearchForm.Header' | translate
      }}"
      [(selected)]="isOpenedSettingSearchFormTab"
    >
      <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
    </p-accordionTab>

    <p-accordionTab
      header="{{ 'AutoPrintSetting.DetailTable.Header' | translate }}"
      [(selected)]="isOpenedSettingDetailTab"
    >
      <ng-content *ngTemplateOutlet="settingDetailTemplate"></ng-content>
    </p-accordionTab>
  </p-accordion>
</p-card>

<ng-template #settingSearchFormTemplate>
  <form [formGroup]="searchFormGroup">
    <!-------------------------------------- Form Field ---------------------------------------------->
    <div class="p-fluid formgrid grid">
      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formFacility">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.Facility" | translate
        }}</label>
        <laas-facility-dropdown
          [isSingle]="true"
          formControlName="facility">
        </laas-facility-dropdown>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formDeliveryType">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.DeliveryType"
            | translate
        }}</label>
        <p-multiSelect
          inputId="formDeliveryType"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          formControlName="deliveryTypes"
          [options]="deliveryTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formDocType">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.DocType" | translate
        }}</label>
        <p-multiSelect
          inputId="formDocType"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          formControlName="docTypes"
          [options]="docTypeOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formOrgId">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.OrgId" | translate
        }}</label>
        <p-multiSelect
          inputId="formOrgId"
          appendTo="body"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
          optionLabel="label"
          optionValue="value"
          formControlName="orgIds"
          [options]="orgIdOptions"
        ></p-multiSelect>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formConsigneeKey">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.ConsigneeKey"
            | translate
        }}</label>
        <laas-customer-dropdown
          formControlName="consigneeKeys"
          [showToggleAll]="false"
          [isMultiple]="true"
          [showLabel]="false"
          [divClass]="'field'"
          [showAllOptionItem]="true"
        ></laas-customer-dropdown>
      </div>

      <div class="col-12 md:col-6 lg:col-4 mb-3">
        <label for="formForwarderCode">{{
          "AutoPrintSetting.DetailTable.SearchForm.Column.ForwarderCode"
            | translate
        }}</label>
        <p-multiSelect
          inputId="formForwarderCode"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          formControlName="forwarderCode"
          [options]="forwarderOptions"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          filterPlaceHolder="{{
            'Common.PlaceHolder.EnterSearchCondition' | translate
          }}"
        ></p-multiSelect>
      </div>
    </div>
    <!-------------------------------------- Form Button ---------------------------------------------->
    <div>
      <button
        pButton
        label="{{ 'Common.Button.Search' | translate }}"
        (click)="searchBtnClick()"
      ></button>
      <button
        pButton
        label="{{ 'Common.Button.Reset' | translate }}"
        class="p-button-secondary ml-2"
        (click)="resetBtnClick()"
      ></button>
    </div>
  </form>
</ng-template>

<ng-template #settingDetailTemplate>
  <div class="mt-2">
    <laas-data-table
      #detailTable
      [dataKey]="'rowId'"
      [tableKey]="detailPreferenceKey"
      [value]="settingDetailData"
      [defaultColumns]="columnOfAutoPrintSettingDetail"
      [loading]="isDetailTableLoading"
      [lazy]="true"
      [editPermission]="editPermissionCode"
      [createNewRow]="createNewRow"
      [inputValid]="dataInputValid"
      (createRow)="createRow($event)"
      (savedData)="saveData($event)"
      (restoreData)="restoreData()"
      (tableOnPage)="tablePageChange($event)"
      (tableOnSort)="tableSort($event)"
      (onRowSelect)="onRowSelect($event)"
      [style]="{ 'overflow-y': 'auto' }"
    >
      <ng-template pTemplate="caption">
        <button
          (click)="exportBtnClick($event)"
          pButton
          class="p-button-info ml-2"
          label="{{ 'Common.Button.Export' | translate }}"
        ></button>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'orgId'">
              <div class="overflow-text">
                {{ rowData[col.field ]| optionsMapping : orgIdOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'consigneeKey'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : consigneeKeyOptionsMapping | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'forwarderCode'">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : forwarderOptions | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'__action'">
              -
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>

          </ng-container>
        </td>
      </ng-template>

      <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">

          <ng-container *ngSwitchCase="'deliveryType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="deliveryTypeOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : orgIdOptions) : 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="orgIdOptions"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'consigneeKey'" class="p-fluid">
            <laas-customer-dropdown
              [isSingle]="true"
              [showClear]="true"
              [permissionCode]="editPermissionCode"
              [divClass]="'p-fluid'"
              [(ngModel)]="rowData[col.field]"
              [showAllOptionItem]="true">
            </laas-customer-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
            <laas-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ rowData[col.field] ? (rowData[col.field] | optionsMapping : forwarderOptions) : 'Common.Message.ChooseOption' | translate}}"
              [filter]="true"
              [virtualScroll]="true"
              [virtualScrollItemSize]="59.2"
              [options]="forwarderOptions"
              filterBy="label,value"
              [(ngModel)]="rowData[col.field]"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </laas-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'docType'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="docTypeOptions"
              [(ngModel)]= "rowData[col.field]"
              (ngModelChange)="updateRptIdOptions(rowData[col.field], rowData)"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'rptId'" class="p-fluid">
            <p-dropdown
              appendTo="body"
              class="p-fluid"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              [filter]="true"
              [options]="rptIdOptions"
              [(ngModel)]="rowData[col.field]"
              (click)="generateRptIdOptions(rowData['docType'])"
              filterPlaceholder="{{'Common.PlaceHolder.EnterSearchCondition' | translate }}">
            </p-dropdown>
            <small *ngIf="!rowData[col.field]" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'numberOfPrint'">
            <div class="overflow-text">
              <p-inputNumber
                [(ngModel)]="rowData[col.field]"
                mode="decimal"
                [min]="0"
                [max]="30"
                (onInput)="onInputHandle($event, rowData)">
              </p-inputNumber>
            </div>
            <small *ngIf="rowData[col.field] == null" class="alert">
              <div class="p-invalid">
                {{ 'Common.Button.Required' | translate }}
              </div>
            </small>
          </ng-container>

          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>

        </ng-container>
      </ng-template>

      <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
        <ng-container [ngSwitch]="col.field">

          <ng-container *ngSwitchCase="'orgId'">
            <div class="overflow-text">
              {{ rowData[col.field ]| optionsMapping : orgIdOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'consigneeKey'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : consigneeKeyOptionsMapping | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'forwarderCode'">
            <div class="overflow-text">
              {{ rowData[col.field] | optionsMapping : forwarderOptions | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'createDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'__action'">
            <i *ngIf="true" class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
        </ng-container>
      </ng-template>

    </laas-data-table>
  </div>
</ng-template>
